import React from 'react'
import styled from 'styled-components'

const MainContainer = styled.div`
  padding: 1rem 1.5rem;
`

const PageWrapper = ({ children }: { children: React.ReactNode }) => {
  return <MainContainer>{children}</MainContainer>
}

export default PageWrapper
